import React from 'react';
import classNames from 'classnames';
import Button from '../elements/Button';
import { company } from '../../data/products';

const About = ({ className, ...props }) => {

  const outerClasses = classNames('section about center-content', className);

  return (
    <section {...props} id="about" className={outerClasses}>
      <div className="container-sm">
        <div className="section-inner has-top-divider">
          <p className="product-kicker text-xxs m-0 reveal-from-bottom">About</p>
          <h2 className="mt-8 mb-16 reveal-from-bottom" data-reveal-delay="100">{company.legalName}</h2>
          <div className="container-xs">
            <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="200">{company.description}</p>
          </div>
          <div className="reveal-from-bottom" data-reveal-delay="300">
            <Button tag="a" color="dark" wideMobile href={`mailto:${company.email}`}>
              {company.email}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
